import React from 'react';
import PropTypes from 'prop-types';

const PaymentMethod = ({value, onChange = () => {}}) => (
    <div id="payment" className="choose-payment">
        <div className="choose-payment__title">
            Payment method:
        </div>
        <div className="choose-payment__wrp">
            <div className="choose-payment__item credit-card selected">
                <input type="radio" name="payment_method" value="credit_car" checked={value === 'creditCard'} onChange={() => {}} />
                <label htmlFor="p1" className="payment-method-card cards radioSelect__label" onClick={() => onChange('creditCard')}>
                    <div className="choose-payment__check">

                        <span className="radio_custom"><span></span></span>

                        <span>Credit Card</span>
                    </div>
                    <div className="choose-payment__img choose-payment__img--card">
                        <img src="/images/credit-card.png" alt="credit card"/>
                    </div>
                </label>
            </div>
            <div className="choose-payment__item paypal">
                <input type="radio" name="payment_method" value="paypal" checked={value === 'paypal'} onChange={() => {}} />
                <label htmlFor="p2" className="payment-method-paypal cards radioSelect__label" onClick={() => onChange('paypal')} >
                    <div className="choose-payment__check">

                        <span className="radio_custom"><span></span></span>

                        <span>PayPal</span>
                    </div>
                    <div className="choose-payment__img">
                        <img src="/images/smallPaypal.png" alt="Paypal" />
                    </div>
                </label>
            </div>
        </div>
    </div>
)

PaymentMethod.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
};

export default PaymentMethod
